module.exports = __webpack_public_path__ + "img/hangzhixinlogo-baise-wangzhan.89f59c49.png";